export const styles = {
  Card: {}
};
